/**
 * bootprompt.js locale configuration
 * locale : Spanish
 * author : Ian Leckey
 */

import { addLocale } from "../bootprompt";

addLocale("es", {
  OK: "OK",
  CANCEL: "Cancelar",
  CONFIRM: "Aceptar",
});
